<h4 class="title" *ngIf="show()">
  {{'shared.elements.mobile.not-avialable.title' | translate }}
</h4>